// Indian mobile-number data sanity: digits only, exactly 10 (no +91, no spaces).

/** Strip everything non-numeric and drop a country-code / leading-0 prefix (keep last 10). */
export function normalizePhone(raw: string | null | undefined): string {
  let d = (raw ?? "").replace(/\D/g, "");
  if (d.length > 10) d = d.slice(-10);
  return d;
}

/** True when the value is exactly 10 digits. */
export const PHONE_REGEX = /^\d{10}$/;
export function isTenDigits(v: string | null | undefined): boolean {
  return PHONE_REGEX.test(v ?? "");
}

export const PHONE_HELP = "Enter a 10-digit mobile number (no +91, no spaces)";
